<template>
    <div class="order-roles">
        <Accordion class="order-roles-accordion">
            <template #head>
                <div>Roles</div>
            </template>

            <template #content>
                <SimpleFlexTable :data="computedRoles" :head="['Name', 'Speaker']">
                    <template #default="{ item }">
                        <span v-text="item.name" />
                        <span v-text="item.speaker" />
                    </template>
                </SimpleFlexTable>
            </template>
        </Accordion>
    </div>
</template>

<script>
import { Accordion } from '@speechki-frontend/shared/ui/Accordion/';
import SimpleFlexTable from '@speechki-frontend/shared/ui/SimpleFlexTable/SimpleFlexTable';

export default {
    name: 'OrderRoles',
    components: {
        Accordion,
        SimpleFlexTable,
    },
    props: {
        roles: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        computedRoles() {
            const { locale } = this.$i18n;
            return this.roles.map((item) => {
                const { name } = item;
                const speaker =
                    'name' in item.speaker
                        ? item.speaker.name[locale]
                        : `Speaker id ${item.speaker.id}`;

                return { id: item.speaker.id, name, speaker };
            });
        },
    },
    methods: {
        openTransitionActions(transition) {
            this.$refs.actions.open(transition);
        },
    },
};
</script>

<style lang="scss" src="./OrderRoles.scss"></style>
